export default "__VITE_ASSET__DjrkzTKi__"